import * as Yup from "yup";

export const manualStockSchema = Yup.object().shape({
  reason: Yup.string().required("O motivo é obrigatório"),

  quantity: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? null : Number(originalValue),
    )
    .typeError("A quantidade deve ser um número")
    .required("A quantidade é obrigatória"),

  product_slug: Yup.string().required("O produto é obrigatório"),

  type: Yup.mixed<"Entry" | "Exit">()
    .oneOf(["Entry", "Exit"], "Tipo de movimentação inválido")
    .required("O tipo de movimentação é obrigatório"),
});
